// Flag de "ya vio la explicación" del botón de verificación. Por navegador, no por
// cuenta: es una ayuda de primera vez, no una preferencia.
export const CLAVE_EXPLICADA = 'atlas-verificacion-calidad-explicada';

type Lector = Pick<Storage, 'getItem'>;
type Escritor = Pick<Storage, 'setItem'>;

const storageDefault = (): Storage | null => {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
};

export function yaExplicada(storage: Lector | null | undefined = storageDefault()): boolean {
  try {
    return storage?.getItem(CLAVE_EXPLICADA) === '1';
  } catch {
    return false;
  }
}

export function marcarExplicada(storage: Escritor | null | undefined = storageDefault()): void {
  try {
    storage?.setItem(CLAVE_EXPLICADA, '1');
  } catch {
    /* modo privado o storage lleno: se vuelve a explicar la próxima */
  }
}
